// extracted by mini-css-extract-plugin
export default {"content":"Home_content__0gRrs"};